// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BXdV","type":"styles_type__1e0Kv","choices":"styles_choices__1wCbj"};